import Vue from "vue";
import VueRouter from "vue-router";
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";
import pages from "./routes/pages";
import user from "./routes/user";
import settings from "./routes/settings";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        Permission: "home_page_menu",
      },
    },

    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/views/Tool/Dashboard.vue"),
      meta: {
        Permission: "tool_page_menu",
        publishedRota: false,
      },
    },

    {
      path: "/published-rota",
      name: "published-rota",
      component: () => import("@/views/Tool/Dashboard.vue"),
      meta: {
        Permission: "rota_live_page_menu",
        publishedRota: true,
      },
    },

    {
      path: "/report",
      name: "report",
      component: () => import("@/views/Report/Report.vue"),
      meta: {
        Permission: "report_page_menu",
      },
    },

    {
      path: "/reviews/add",
      name: "review-add",
      component: () => import("@/views/reviews/ReviewAdd.vue"),
      meta: {
        Permission: "add_review",
      },
    },

    {
      path: "/reviews/list",
      name: "review-list",
      component: () => import("@/views/reviews/ReviewList.vue"),
      meta: {
        Permission: "view_review_list",
      },
    },

    {
      path: "/reviews/edit/:id",
      name: "review-edit",
      component: () => import("@/views/reviews/EditReview.vue"),
      meta: {
        Permission: "no_permission_required",
      },
    },

    {
      path: "/reviews/report",
      name: "review-report",
      component: () => import("@/views/reviews/ReviewReport.vue"),
      meta: {
        Permission: "view_review_report",
      },
    },

    // Geçici route - OldReviewReport için
    {
      path: "/reviews/old-report",
      name: "old-review-report",
      component: () => import("@/views/reviews/OldReviewReport.vue"),
      meta: {
        Permission: "view_review_report",
      },
    },

    {
      path: "/reviews/preview/:id",
      name: "review-preview",
      component: () => import("@/views/reviews/ReviewPreview.vue"),
      meta: {
        Permission: "no_permission_required",
      },
    },

    {
      path: "/summary/:id",
      name: "summary-explanation",
      component: () => import("@/views/reviews/ReviewSummaryExplanation.vue"),
      meta: {
        Permission: "view_individual_summary",
      },
    },

    {
      path: "signout",
      name: "signout",
      component: () => import("@/views/LogOut.vue"),
      meta: {
        Permission: "no_permission_required",
      },
    },

    ...pages,
    ...user,
    ...settings,
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();

  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: "auth-login" });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
  }

  if (isLoggedIn) {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const userPerms = JSON.parse(localStorage.getItem('userPerms'));
    if (userData.role === 'supermanager' || userData.role === 'admin' || userData.role === 'Regional Admin' || userData.role === 'System Admin') {
      return next();
    } else {
      if (to.meta.Permission === "no_permission_required") {
        return next();
      } else {

        if(userData.quality_reviewer == true && ["add_review","edit_review", "view_review_list"].includes(to.meta.Permission)){
          return next();
        }

        if (userPerms.includes(to.meta.Permission) == false) {
          if (to.meta.Permission === "home_page_menu") {
            next({ path: "dashboard" });
          } else {
            next({ path: "not-authorized" });
          }
        } else {
          return next();
        }
      }
    }
  } else {
    return next();
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
